<template>
  <c-form-group :id="id"
                v-slot="{ valid, errors, required, reset, invalid, dirty }"
                :form-group-class="formGroupClass"
                :inline="inline"
                :input-wrapper-class="inputWrapperClass"

                :label="label"
                :label-class="labelClass"
                :label-invisible="labelInvisible"
                :label-right="labelRight"

                :validate-custom-messages="validateCustomMessages"
                :validate-disabled="validateDisabled"
                :validate-rules="validateRules"
                :validate-vid="validateVid"
  >
    <select2 :id="id"
             v-bind="$attrs"
             :data-ajax--delay="url ? 250: null"
             :data-ajax--url="url"
             :data-placeholder="placeholder || label"
             :is-invalid="errors[0] ? true : false"
             :value="value"
             @input="$emit('input', $event)">
      <slot></slot>
    </select2>

    <b-form-invalid-feedback v-if="errors[0]" style="cursor: pointer" @click="reset()">* {{ errors[0] }}</b-form-invalid-feedback>
  </c-form-group>
</template>

<script>
import Select2 from "./Select2"

export default {
  name: "CSelect2",
  components: {
    Select2
  },
  props: {
    config: Object,
    options: Array,
    value: {
      type: [String, Number, Object]
    },
    placeholder: String,
    uri: String,

    formGroupClass: String,
    inline: Boolean,
    inputWrapperClass: String,
    label: String,
    labelClass: String,
    labelRight: Boolean,
    labelInvisible: Boolean,

    validateVid: String,
    validateRules: [Object, String],
    validateDisabled: Boolean,
    validateCustomMessages: Object,
  },
  computed: {
    url() {
      if (this.uri) {
        return process.env.VUE_APP_API_URL + this.uri;
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      id: null
    }
  },
  mounted() {
    this.id = 'CSelect2-' + this._uid;

    // setTimeout(() => {
    //   console.log($("#" + this.id).select2());
    // }, 1000)
  }
}
</script>

<style scoped>

</style>